import { DocumentItem, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getDocuments = async (groupId: number, locale: string): Promise<DocumentItem[]> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.Documents}?marketLocale=${encodeURIComponent(locale)}`;
    const response = await knowledgeBaseHttp.get<DocumentItem[]>(url);

    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching Documents:`, error);
    return [];
  }
};
